<script>
  import { appleProvider, auth, fbProvider, googleProvider } from '../firebase';

  import { doLogin } from '../helpers/login';
  let loading = false;
  let errorMsg;

  const handleSignin = (providerStr) => {
    let provider;
    switch (providerStr) {
      case 'google':
        provider = googleProvider;
        break;
      case 'fb':
        provider = fbProvider;
        break;
      case 'apple':
        provider = appleProvider;
        break;
    }
    loading = true;
    auth
      .signInWithPopup(provider)
      .then((val) => {
        const firebaseUser = val.user;
        if (firebaseUser) {
          doLogin(firebaseUser);
          loading = false;
        } else {
          console.error('No user found');
        }
      })
      .catch((e) => {
        console.log('fff');
        console.error(e);
        errorMsg = e.message;
      })
      .finally(() => (loading = false));
  };
</script>

{#if errorMsg}
  <div class="message is-danger">
    <div class="message-body">
      There was an error with sign in. <br /><br />
      {errorMsg}
    </div>
  </div>
{/if}

<button
  class="button is-block is-link is-fullwidth is-medium"
  on:click={() => handleSignin('google')}
  class:loading
>
  <i class="fa fa-google" />
  Sign in with Google
</button>
<br />
<button
  class="button is-block is-dark is-fullwidth is-medium"
  on:click={() => handleSignin('apple')}
  class:loading
>
  <i class="fa fa-apple" />
  Sign in with Apple
</button>
<br />
<button
  class="button is-block is-info is-fullwidth is-medium"
  on:click={() => handleSignin('fb')}
  class:loading
>
  <i class="fa fa-facebook" />
  Sign in with Facebook
</button>
